const MuiMenuOverrides = {
  MuiMenu: {
    styleOverrides: {
      list: {
        padding: 0
      },
      paper: {
        borderRadius: '0 !important'
      }
    },
    defaultProps: {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: _ref => {
        let {
          theme
        } = _ref;
        return {
          ...theme.typography.body01,
          minHeight: theme.spacing(5),
          [theme.breakpoints.up('sm')]: {
            minHeight: theme.spacing(5)
          }
        };
      }
    }
  }
};

export { MuiMenuOverrides };
